@if (!btnDisabled()) {
  <button
    #btn
    [type]="btnType()"
    [class]="classesString()"
    (click)="triggerEvent()"
    [attr.data-track-category]="trackCategory()"
    [attr.data-track-action]="getTrackAction()"
    [attr.data-track-value]="trackValue()"
    [attr.data-cy]="dataCyAttribute()"
  >
    @if (isLoading()) {
      <i
        class="spinner-border spinner-border-sm text-primary my-auto"
        role="status"
        [ngClass]="spinnerClassesString()"
      ></i>
    }
    @if (icon() && icon().length && !isLoading()) {
      <i [class]="iconClassesString()"></i>
    }
    {{ label() | translate }}
  </button>
}
@if (btnDisabled()) {
  <button
    #btn
    disabled
    [type]="btnType()"
    [class]="classesString()"
    [attr.data-track-category]="trackCategory()"
    [attr.data-track-action]="getTrackAction() + '-disabled'"
    [attr.data-track-value]="trackValue()"
    [attr.data-cy]="dataCyAttribute()"
  >
    @if (isLoading()) {
      <i
        class="spinner-border spinner-border-sm text-primary my-auto"
        role="status"
        [ngClass]="spinnerClassesString()"
      ></i>
    }
    @if (icon() && icon().length && !isLoading()) {
      <i [class]="iconClassesString()"></i>
    }
    {{ label() | translate }}
  </button>
}
